import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { _OPEN_CONFIRMATION_, CONTRACT_ITEM_SELECT, SELECT_MODAL } from '_modules/quotation/components/QuotationModel';
import { hasLoadedTypeOptions } from './installmentsPlan';

export default {
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getHireds',
      'getContractors',
      'getItemsIncluded',
      'getPaymentInfo',
      'getTypeOptions',
      'getSettings',
    ]),
    ensureSettings() {
      if (this.$store.state.settings.settings) {
        return Promise.resolve();
      }
      return this.getSettings();
    },
    ensureTypeOptionsThenApply(groupIndex = null) {
      const typeReady = hasLoadedTypeOptions(this.typeOptionsFromStore)
        ? Promise.resolve()
        : this.getTypeOptions();
      return Promise.all([typeReady, this.ensureSettings()]).then(() => {
        this.applyTypeForwardInstallments(groupIndex);
      });
    },
    addGroupRow(rowModel, groupIndex) {
      const group = this.model?.[groupIndex];
      if (group && Array.isArray(group.rows)) {
        group.rows.push(cloneDeep(rowModel));
      }
    },
    removeGroupRow(groupIndex, rowIndex) {
      const group = this.model?.[groupIndex];
      if (group?.rows?.[rowIndex] !== undefined) {
        group.rows.splice(rowIndex, 1);
      }
    },
    addGroupTab(groupModel, title) {
      const newGroup = { ...cloneDeep(groupModel), name: title };
      this.model.push(newGroup);
      this.updateTabs();
      this.selectTab(this.model.length - 1);
    },
    duplicateTab(index) {
      const original = this.model?.[index];
      if (!original) return;

      const copy = {
        ...cloneDeep(original),
        id: null,
        name: `${original.name} - cópia`,
        rows: original.rows.map(row => ({
          ...row,
          id: null,
          group_id: null,
        })),
      };

      this.model.push(copy);
      this.updateTabs();
      setTimeout(() => {
        this.setProductInAutocomplete();
      });
      this.selectTab(this.model.length - 1);
    },
    deleteTab(index) {
      if (this.model?.[index]) {
        this.model.splice(index, 1);
        this.updateTabs();
        this.setProductInAutocomplete();
      }
    },
    refsUpdateTabs() {
      if (this.$refs.tabs?.updateTabs && typeof this.$refs.tabs.updateTabs === 'function') {
        this.$refs.tabs.updateTabs();
      }
    },
    updateTabs() {
      setTimeout(() => {
        this.refsUpdateTabs();
      }, 10);
    },
    selectTab(index) {
      this.$nextTick(() => {
        this.refsUpdateTabs();
        this.selectedGroup = index;

        const focused = document.activeElement;
        if (focused instanceof HTMLElement) focused.blur();
      });
    },
    confirmDeleteTab(index) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_OPEN_CONFIRMATION_, { quotation: index, type: 'deleteTab' });
    },
    setObjectErrors() {
      if (Array.isArray(this.model)) {
        this.model.forEach(group => {
          group.errors = this.errors;
        });
        this.$nextTick(() => {
          this.$emit('update:groups', this.model);
        });
      }
    },
    hasError(group, field) {
      if (group?.errors) {
        if (group?.errors?.[field]?.required) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
    ensureRowShowImage() {
      if (!Array.isArray(this.model)) return;
      this.model.forEach(group => {
        (group.rows || []).forEach(item => {
          this.$set(item, 'show_image', !!item.show_image);
        });
      });
    },
    loadModel() {
      this.ensureRowShowImage();
      this.updateTabs();
      this.setObjectErrors();
      this.setProductInAutocomplete();
    },
    openContractItemSelect(type, index, model) {
      const config = CONTRACT_ITEM_SELECT[type];
      const modal = config && SELECT_MODAL[config.mode];
      if (!modal) return;

      this.setToggle({ type: modal.toggle, bool: true });
      Events.$emit(modal.event, {
        type,
        index,
        [modal.payloadKey]: model[config.field],
      });
    },
    getObligationOptions() {
      const { settings } = this.$store.state;
      Object.keys(CONTRACT_ITEM_SELECT).forEach(type => {
        const { load } = CONTRACT_ITEM_SELECT[type];
        if (!settings[type] && typeof this[load] === 'function') {
          this[load]();
        }
      });
    },
    onInputProduct(name, activePriceTable) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getProductVariations({ search: name, priceTable: activePriceTable });
      }, 500);
    },
  },
};
